import { render, staticRenderFns } from "./ReturnReceiveItem.vue?vue&type=template&id=6f44ee48&scoped=true"
import script from "./ReturnReceiveItem.vue?vue&type=script&lang=js"
export * from "./ReturnReceiveItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f44ee48",
  null
  
)

export default component.exports